import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { keyframes } from 'styled-components';
import * as DotProgress_tokens from './DotProgress.tokens.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color", "size"];
var opacity = keyframes(["0%{opacity:1;}100%{opacity:0.5;}"]);
var Svg = styled.svg.withConfig({
  displayName: "DotProgress__Svg",
  componentId: "sc-1s6o2q7-0"
})(["fill:", ";circle{&:nth-child(1){animation:", " 1s ease infinite;}&:nth-child(2){animation:", " 1s ease 0.2s infinite;}&:nth-child(3){animation:", " 1s ease 0.4s infinite;}}"], function (_ref) {
  var color = _ref.color;
  return color;
}, opacity, opacity, opacity);
var getColor = function getColor(color) {
  if (DotProgress_tokens[color]) {
    return DotProgress_tokens[color].background;
  }
  return color;
};
var DotProgress = /*#__PURE__*/forwardRef(function DotProgress(_ref2, ref) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'neutral' : _ref2$color,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 32 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var props = _objectSpread(_objectSpread({}, rest), {}, {
    color: getColor(color),
    ref: ref
  });
  var height = size / 4;
  var width = size;
  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({}, props), {}, {
    role: "progressbar",
    viewBox: "0 0 16 4",
    height: height,
    width: width,
    preserveAspectRatio: "xMidYMid meet",
    children: [/*#__PURE__*/jsx("circle", {
      cx: 2,
      cy: 2,
      r: 2
    }), /*#__PURE__*/jsx("circle", {
      cx: 8,
      cy: 2,
      r: 2
    }), /*#__PURE__*/jsx("circle", {
      cx: 14,
      cy: 2,
      r: 2
    })]
  }));
});

export { DotProgress };
